import { useEffect } from 'react';
import axios from 'utils/api';
import { RecommendationSelections } from 'utils/recommendations-strip-logic';

// Debounced persistence for the recommendation strip's controlled mode
// (AHA-6681 LES-2), following the autosave-watcher debounced-useEffect
// convention. The LES-3 parent starts `selections` at null and only sets it
// from the strip's onSelectionsChange, so restore never echo-saves.
//
// Deliberately no toasts: this fires on keystroke-level changes (too chatty
// for the coarse autosave 'Saved' convention) and persistence is best-effort
// — the next change retries, and the strip's own errors are non-fatal by
// design. Known accepted edge: a change made <500ms before a system switch
// is dropped (the cleanup clears the timer — correct, since the closure
// holds the old system's payload).
export default function useRecommendationSelectionsSave(
  systemUniqueId: string | null,
  selections: RecommendationSelections | null
) {
  useEffect(() => {
    if (!systemUniqueId || !selections) return undefined;
    const timer = setTimeout(async () => {
      try {
        await axios.patch(
          `existing-equipment/${systemUniqueId}/recommendation-selections`,
          selections
        );
      } catch (error) {
        console.error('Error saving recommendation selections:', error);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [systemUniqueId, selections]);
}
